module.exports = __webpack_public_path__ + "img/渼淳玉颜.b09f1e5.png";